import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils';
import { postRequest , getRequest} from '../../config/AxiosConfig';

const apiBaseUrlProd = API_URLS.PROD;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};




export const getInstallmentById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/installment/get-by-mandate",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};




export const skipInstallmentById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/installment/skip",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};




export const refreshInstallmentById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/installment/refresh",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};



export const retryInstallmentById = async (payload) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "auto-debit-r/installment/retry",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error(
      "Error fetching mandate:",
      error.response?.data || error.message
    );
    throw error;
  }
};